import React, { useContext } from "react";
import { AppContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { IconButton, Paper, Typography } from "@material-ui/core";
import { createPercentageBar } from '../helpers/constants';
import SVGComponent from "./SVGComponent";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';



export default function StatisticsCard(props) {

  const state = useContext(AppContext);
  const s = state.strings;

  const { title, color, typeId, handleChange, helpUrl } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      cursor: "pointer",
      height: 88,
      width: 348,
      marginLeft: theme.spacing(1),
      margin: theme.spacing(1),
      padding: theme.spacing(1),
      transition: "background-color 0.4s",
      boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
      "&:hover": {
        backgroundColor: '#eeeeee',
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.3)",
        transition: "background-color 0.4s",
      }
    },
    title: {
      fontWeight: 600
    }
  }));
  const classes = useStyles();
  const selected = (state.ui.statisticsType == typeId);

  const barValueArray = (overlayStatistics) => {
    let mode = state.ui.statisticsMode;
    let data = overlayStatistics['phrases'] && overlayStatistics['phrases'].map((value, index) => [value, overlayStatistics[typeId] ? overlayStatistics[typeId][index][mode] : 0]);
    return data;
  }

  const getStatsValues = () => state.ui.textOverlay[typeId] ? state.ui.textOverlay[typeId].values : state.ui.textOverlay['default'].values;
  const getStatsColors = () => state.ui.textOverlay[typeId] ? state.ui.textOverlay[typeId].colors : state.ui.textOverlay['default'].colors;

  const openHelpUrl = (e, url) => {
    window.open(url, "_blank");
    e.stopPropagation();
  };

  return (
    <Paper className={classes.root} onClick={() => { handleChange && handleChange(typeId) }} style={{ backgroundColor: (selected) ? "#D9D9D9" : color }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <Typography style={{ padding: 0, margin: 0}} paragraph color="secondary" variant="body1">{title}</Typography>
        <IconButton onClick={(e) => openHelpUrl(e, helpUrl)} color="secondary" size="small" data-for="globalTT" data-tip={s.kiDetector.help} >
          <HelpOutlineIcon />
        </IconButton>
      </div>

      {(state.overlayStatistics) &&

        <SVGComponent width={330} height={16} svgString={createPercentageBar(330, 16, getStatsColors(), getStatsValues(), barValueArray(state.overlayStatistics))}></SVGComponent>
      }
    </Paper>
  );
}
